import { supabase } from './supabase';
import type { User } from '../types/user';

export async function signIn(email: string, password: string): Promise<User> {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;

    if (!data.user) {
      throw new Error('Invalid email or password');
    }

    return {
      id: data.user.id,
      email: data.user.email!,
      full_name: data.user.user_metadata.full_name
    };
  } catch (error) {
    console.error('Sign in error:', error);
    throw error;
  }
}

export async function signUp(email: string, password: string, full_name: string, website?: string): Promise<void> {
  try {
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          full_name,
          website
        },
        emailRedirectTo: `${window.location.origin}/auth/callback`
      }
    });

    if (error) throw error;
  } catch (error) {
    console.error('Sign up error:', error);
    throw error;
  }
}